'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export function RefTracker({ code }: { code: string }) {
  const router = useRouter()

  useEffect(() => {
    if (!code) return
    // Set 30-day referral cookie
    document.cookie = `booking_ref=${encodeURIComponent(code)};path=/;max-age=${30 * 24 * 60 * 60};SameSite=Lax`
    // Clean URL
    router.replace('/')
  }, [code, router])

  return null
}
